import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'

const COOKIE_KEY = 'taprize_cookie_consent'

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY)
    if (!consent) {
      setVisible(true)
    }
  }, [])

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted')
    setVisible(false)
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 inset-x-0 z-50 p-4"
          role="region"
          aria-label="Bannière cookies"
        >
          <div className="mx-auto max-w-xl rounded-2xl border border-border bg-bg-card px-5 py-4 shadow-[0_-4px_24px_rgba(0,0,0,0.3)] backdrop-blur">
            <p className="text-sm text-text-muted leading-relaxed">
              Ce site utilise uniquement des cookies techniques nécessaires au fonctionnement du service. Aucun cookie publicitaire ou de traçage n'est utilisé.{' '}
              <Link to="/confidentialite" className="text-primary hover:underline">
                En savoir plus
              </Link>
            </p>
            <div className="mt-3 flex justify-end">
              <button
                onClick={accept}
                className="rounded-xl bg-primary px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2"
              >
                Compris
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
